import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

interface CrewRouteProps {
  children: React.ReactNode;
}

const CrewRoute: React.FC<CrewRouteProps> = ({ children }) => {
  const { isAuthenticated, isCrew, isLoading } = useAuth();
  const location = useLocation();

  // Show loading state while checking auth
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#3A5E63]"></div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Redirect to profile if authenticated but not crew
  if (!isCrew) {
    return (
      <Navigate
        to="/profile"
        state={{
          from: location,
          error: 'Access denied. Crew privileges required.'
        }}
        replace
      />
    );
  }

  // Render children if authenticated and crew
  return <>{children}</>;
};

export default CrewRoute;
